ko.bindingHandlers['show'] = {
    update: function (element: HTMLElement, valueAccessor, allBindings, viewModel, bindingContext)
    {

        const value = ko.unwrap(valueAccessor());

        //based on opacity, so no  fiddling with removed items
        if (allBindings().display === 'opacity') {

            if (value) {
                element.style.opacity = '1';
                element.style.pointerEvents = 'auto'
            } else {
                element.style.opacity = '0';
                element.style.pointerEvents = 'none'

            }

        } else {
            //or based on display, but the option to set the display-value
            if (value) {
                element.style.display = allBindings().display ?? 'block';
            } else {
                element.style.display = 'none';
            }
        }

    }
};  